<template>
    <div class="wens" v-bind:class="{'favoriet':wens.favoriet}">
        <div class="leuk"></div>
        <img :src="wens.cover" :alt="wens.titel" />
        <label>
            <input type="checkbox" v-on:change="wijzigVoorkeur">
            <h3>{{wens.titel}}</h3>
            <p>{{wens.auteur}}</p>
            <p class="kenmerken">{{wens.ean}} | {{wens.paginas}} bladzijden | {{wens.uitgave}} | {{wens.taal}} | &euro;{{wens.prijs}}</p>
        </label>
        <span class="weg" @click="$emit('verwijder-wens', wens.ean)">&Cross;</span>
        
    </div>
</template>

<script>
export default {
    name: "Wens",
    props: ["wens"],
    methods: {
        wijzigVoorkeur() {
            this.wens.favoriet = !this.wens.favoriet;
        }
    }
}
</script>

<style scoped>
    .wens {
        background-color: #f0f0f0;
        border-bottom : 2px dotted grey;
        padding : 1em;
        display: grid;
        grid-template-columns:2em 5em 1fr auto;
        grid-gap: 1em;
    }
    label {
        display: grid;
        grid-template-rows:  auto 1fr auto auto;
    }
    .favoriet {
        color: darkred;
    }
    .favoriet .leuk::after {
        content: " 👍";
        font-size: 1rem;
    }
    .favoriet ~ .weg {
        color: lightgray;
    }
    .weg {
        font-size: 2.5em;        
        cursor: pointer;
        color: black;
    }

    .weg:hover {
        font-size: 2.9em;
        color: red;
    }
    input {
        display: none;
    }
    img {
        max-width: 100%;
    }
    .kenmerken {
        font-size: .8rem;
    }
</style>